/* Black Friday countdowns. Any element with data-gx-countdown="<ISO end>" gets its
   [data-gx-clock] text or [data-u] blocks updated every second, and is hidden once the sale ends. */
(() => {
  const els = [...document.querySelectorAll('[data-gx-countdown]')];
  if (!els.length) return;
  const pad = n => String(n).padStart(2, '0');
  function tick() {
    const now = Date.now();
    for (const el of els) {
      const left = new Date(el.dataset.gxCountdown).getTime() - now;
      if (left <= 0) { el.classList.add('is-over'); continue; }
      const s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600),
            m = Math.floor(s % 3600 / 60), sec = s % 60;
      const u = { d, h: pad(h), m: pad(m), s: pad(sec) };
      el.querySelectorAll('[data-u]').forEach(b => { b.textContent = u[b.dataset.u]; });
      el.querySelectorAll('[data-gx-clock]').forEach(c => { c.textContent = `Ends in ${d}d ${pad(h)}h ${pad(m)}m ${pad(sec)}s`; });
    }
  }
  tick(); setInterval(tick, 1000);
})();
